/* eslint-disable array-callback-return */
// import _ from 'lodash';
import { COLORS } from 'shared/constants';
import { ACTION_TYPE } from 'shared/redux/actions/actionTypes';
import api from 'shared/services/api';
import numeral from 'numeral';

const getAssetAllocation = () => (dispatch, getState) => new Promise((resolve) => {
  const { summary } = getState().rootReducer;

  const initialInvestment = numeral(summary['summary.initialInvestment']).value();
  const isRetail = initialInvestment >= 5000 && initialInvestment <= 99999;
  const isAffluent = initialInvestment >= 100000 && initialInvestment <= 250000;
  // console.log('geo alloc ', summary['summary.geographicalInterest'].split(', '))
  const req = {
    risk: summary['summary.risk'],
    listOfGeography: summary['summary.geographicalInterest'].split(', '),
    investmentType: summary['summary.investmentPreference'] === 'islamic' ? 2 : 1,
    // eslint-disable-next-line no-nested-ternary
    clientSegment: isRetail ? 'retail' : isAffluent ? 'affluent' : 'private',
    isSharia: summary['summary.isSharia'],
  };

  api.getAssetAllocation(req)
    .then((res) => {
      const assetAllocation = res.assetAllocation.map((item, idx) => ({
        ...item,
        label: item.name,
        value: item.weight,
        color: COLORS[idx],
      }));

      const tacticleAsset = [];
      for (let i = 0; i < res.assetAllocation.length; i += 1) {
        tacticleAsset.push({
          ...res.assetAllocation[i],
          label: res.assetAllocation[i].name,
          value: `${res.assetAllocation[i].weight} %`,
          color: COLORS[i],
        });
        const { assetAllocationDetails } = res.assetAllocation[i];
        for (let j = 0; j < assetAllocationDetails.length; j += 1) {
          const { fundDetails } = assetAllocationDetails[j];
          for (let t = 0; t < fundDetails.length; t += 1) {
            tacticleAsset.push({
              ...fundDetails[t],
              label: fundDetails[t].instrumentName,
              value: `${numeral(fundDetails[t].weight).format('0.0')} %`,
            });
          }
        }
      }

      dispatch({
        type: ACTION_TYPE.SAVE_ASSET_ALLOCATION,
        payload: {
          assetAllocation,
          assetAllocationDetails: res.assetAllocationDetails,
          isinCodes: res.isinCodes,
          tacticleAsset,
        },
      });

      resolve(res);
    })
    .catch((err) => {
      console.log(err);
    });
});

export default getAssetAllocation;
